export const ErrorMessage = {
  WINDOW_IS_NOT_DEFINED: 'Window is not defined',
  URL_IS_NOT_DEFINED: 'Url is not defined',
  TIMEOUT: 'Timeout',
  ABORTED: 'Aborted',
} as const;
